import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { SectorModel } from 'src/app/models/management/sector.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SectorService {

  constructor(private _httpClient: HttpClient) { }

  createSector(sectorContract: SectorModel): Observable<SectorModel> {
    return this._httpClient.post<SectorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.CreateAsync}`,
      sectorContract);
  }

  deleteSector(sectorId: number): Observable<SectorModel> {
    return this._httpClient.delete<SectorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.DeleteAsync}/${sectorId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllSectorsForSelect(cityId: number): Observable<Array<any>> {
    const params = new HttpParams().set('cityId', cityId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.GetAllSectorsForSelectAsync}`,
      { params: params }
    );
  }

  getAllSectorsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.GetAllSectorsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getSectorById(sectorId: number): Observable<SectorModel> {
    const params = new HttpParams().set('sectorId', sectorId);
    return this._httpClient.get<SectorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.GetByIdAsync}`,
      { params: params }
    );
  }

  getSectorByKeys(cityId: number, consecutive: number): Observable<SectorModel> {
    const params = new HttpParams().set('cityId', cityId).set('consecutive', consecutive);
    return this._httpClient.get<SectorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.GetSectorByKeysAsync}`,
      { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstSectorByKeys(cityId: number): Observable<SectorModel> {
    const params = new HttpParams().set('cityId', cityId);
    return this._httpClient.get<SectorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.GetFirstSectorByKeysAsync}`,
      { params: params }
    );
  }

  getLastSectorByKeys(cityId: number): Observable<SectorModel> {
    const params = new HttpParams().set('cityId', cityId);
    return this._httpClient.get<SectorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.GetLastSectorByKeysAsync}`,
      { params: params }
    );
  }

  getNextSectorByKeys(cityId: number, consecutive: number): Observable<SectorModel> {
    const params = new HttpParams().set('cityId', cityId).set('consecutive', consecutive);
    return this._httpClient.get<SectorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.GetNextSectorByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusSectorByKeys(cityId: number, consecutive: number): Observable<SectorModel> {
    const params = new HttpParams().set('cityId', cityId).set('consecutive', consecutive);
    return this._httpClient.get<SectorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.GetPreviusSectorByKeysAsync}`,
      { params: params }
    );
  }

  updateSector(sectorContract: SectorModel): Observable<SectorModel> {
    return this._httpClient.put<SectorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.sector.UpdateAsync}`,
      sectorContract);
  }
}
